import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorResponse } from '../../utils/errorUtils';
import type { RootState } from '../store';

/**
 * Interface representing the error state structure
 * @interface ErrorState
 */
export interface ErrorState {
  /** Current error information, null if no error */
  error: ErrorResponse | null;
}

const initialState: ErrorState = {
  error: null,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    /**
     * Set an error in the store
     * @param state - Current error state
     * @param action - Action containing error payload
     */
    setError: (state, action: PayloadAction<ErrorResponse>) => {
      state.error = action.payload;
    },

    /**
     * Clear the current error from the store
     * @param state - Current error state
     */
    clearError: state => {
      state.error = null;
    },
  },
});

// Export actions
export const { setError, clearError } = errorSlice.actions;

// Selectors
export const selectError = (state: RootState) => state.error.error;

export default errorSlice.reducer;
